import React from 'react';
import './App.css';
import MrotForm from './components/MrotForm';

function App() {
  return (
    <div className="App">
      <MrotForm/>
    </div>
  );
}

export default App;
